import { render } from "./Modal.vue?vue&type=template&id=584b62a6&scoped=true&ts=true"
import script from "./Modal.vue?vue&type=script&lang=ts"
export * from "./Modal.vue?vue&type=script&lang=ts"

import "./Modal.vue?vue&type=style&index=0&id=584b62a6&scoped=true&lang=css"
import "./Modal.vue?vue&type=style&index=1&id=584b62a6&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-584b62a6"]])

export default __exports__